<div *transloco="let t" class="paginator" [class.paginator--boxed]="!forceCompactView()">
  @if (!forceCompactView()) {

  <div class="paginator__metadata">
    <div class="paginator__page-size">
      <span class="text-ink-muted">{{ t('PAGINATION.PER_PAGE') }}</span>
      <button
        type="button"
        class="page-size-trigger"
        [matMenuTriggerFor]="pageSizeMenu"
        [disabled]="!totalLength() || loading()"
      >
        <span>{{ pageSize() | translocoDecimal : { useGrouping: false } }}</span>
        <mat-icon svgIcon="alt-arrow-down-outline" class="size-3!"></mat-icon>
      </button>

      <mat-menu #pageSizeMenu="matMenu" class="no-menu-padding">
        <ul>
          @for (option of pageSizeOptions(); track option) {
          <li>
            <button
              mat-menu-item
              class="menu-item"
              [class.menu-item--active]="option === pageSize()"
              (click)="updatePageSize(option)"
            >
              {{ option | translocoDecimal : { useGrouping: false } }}
            </button>
          </li>
          }
        </ul>
      </mat-menu>
    </div>
    <p class="paginator__summary">
      {{
        t('PAGINATION.SHOWING_RESULTS', {
          from: from() | translocoDecimal : { useGrouping: false },
          to: to() | translocoDecimal : { useGrouping: false },
          totalLength: totalLength() | translocoDecimal
        })
      }}
    </p>
  </div>
  }

  <div class="paginator__pages">
    <button
      type="button"
      (click)="previousPage()"
      class="page-block page-block--leftmost"
      [disabled]="currentPage() <= 1 || loading()"
      [class.page-block--disabled]="currentPage() <= 1 || loading()"
      [class.page-block--default]="currentPage() > 1 && !loading()"
    >
      {{ t('PAGINATION.PREVIOUS') }}
    </button>

    <div class="overflow-x-auto no-scrollbar border-y border-stroke-soft">
      <div class="flex items-stretch h-full">
        @for (page of pages(); track $index) { @if (page === null) {
        <span class="page-block page-block--middle page-block--disabled text-ink-muted">…</span>
        } @else {
        <button
          type="button"
          (click)="updatePage(page)"
          class="page-block page-block--middle"
          [class.page-block--active]="currentPage() === page"
          [class.page-block--default]="currentPage() !== page"
          [disabled]="loading()"
        >
          {{ page | translocoDecimal : { useGrouping: false } }}
        </button>
        } }
      </div>
    </div>

    <button
      type="button"
      (click)="nextPage()"
      class="page-block page-block--rightmost"
      [disabled]="!totalLength() || currentPage() >= totalPages() || loading()"
      [class.page-block--disabled]="!totalLength() || currentPage() >= totalPages() || loading()"
      [class.page-block--default]="totalLength() && currentPage() < totalPages() && !loading()"
    >
      {{ t('PAGINATION.NEXT') }}
    </button>
  </div>
</div>
